import React from 'react';
import style from './news-list.mod.scss';
import NewsCard from '../card/news-card';

const NewsList = ({ items }) => {
  return (
    <div className={style.list}>
      {items.map((item) => (
        <NewsCard
          key={item.id}
          heading={item.title}
          image={item.image}
          text={item.description}
          page={item.id}
          category={item.category.name}
          date={item.meta.firstPublishedAt}
        />
      ))}
    </div>
  );
};

export default NewsList;
